import { Component, OnInit, Input, ViewChild, OnChanges, AfterViewChecked, ElementRef, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { NgxNeditorComponent } from '@notadd/ngx-neditor/lib/ngx-neditor.component';
import { NEditorConfig } from '../../constant/NEditorConfig';
import { UploadFile } from 'ng-zorro-antd/upload';
import { DialogService } from '../../services/dialog.service';
import { deepCopy } from '@delon/util';
interface FormItem {
  type: string;
  label?: string;
  labelWidth?: number;
  require?: boolean;
  placeholder?: string;
  config?: object;
  width?: string;
  tabList?: Array<any>;
}
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-msg-form',
  templateUrl: './icc-msg-form.component.html',
  styleUrls: ['./icc-msg-form.component.less'],
})
export class IccMsgFormComponent implements OnInit, OnChanges, AfterViewChecked {
  constructor(private dialogService: DialogService, private elementRef: ElementRef, private cdr: ChangeDetectorRef) {}
  @ViewChild('textArea', { static: false }) textArea: any;
  @ViewChild('ngxEditor', { static: false }) ngxEditor: any;
  @Input() form: any;
  @Input() useGuideIndex: boolean;
  @Input() selectedItem: any;
  // 注意：之所以加disabled，是因为如果tab没有被激活时，不在dom上加载editor，防止初始化报错
  @Input() disabled: boolean;

  isShowTags: boolean = true;

  // editor可编辑配置
  editorConfig: any;
  // editor不可编辑配置
  viewConfig: any;

  neditor: any;

  // nz-upload 的预览组件
  isPreviewImage: boolean;
  // nz-upload 的预览组件的图片地址
  previewImageSrc: string;

  ngOnInit() {
    this.editorConfig = NEditorConfig;
    if (!this.selectedItem) {
      this.selectedItem = {};
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initOptions(this.form);
  }

  ngAfterViewChecked(): void {
    let btnWrappers = this.elementRef.nativeElement.getElementsByClassName('btn-wrapper');
    for (let i = 0; i < btnWrappers.length; i++) {
      if (btnWrappers[i].innerHTML) {
        let btnWrapperElement: HTMLElement = btnWrappers[i];
        btnWrapperElement.style.marginBottom = '10px';
        return;
      }
    }
  }

  initOptions(form) {
    if (form && form instanceof Array) {
      form.forEach((item: FormItem) => {
        item.width = item.width || '100%';
        item.label = item.label || '';
        item.labelWidth = item.labelWidth || 80;
        item.require = item.require || false;
        item.placeholder = item.placeholder || '';
        if (!item.hasOwnProperty('config')) {
          item.config = this.createConfigByType(item.type);
        }
        if ('textarea' === item.type) {
          this.textAreaChange(item.config);
        }
        if ('nz-tabset' === item.type && item.tabList instanceof Array) {
          item.tabList.forEach((innerItem: any) => {
            if (!innerItem.hasOwnProperty('disabled')) {
              innerItem.disabled = false;
            }
            this.initOptions(innerItem.form);
          });
        }
      });
    }
  }

  tabChange(index: number, tabItem: any) {
    tabItem.activeIndex = index;
  }

  /*
   * 对于缺少config的组件配置，创建默认的config对象
   */
  createConfigByType(type) {
    const config: any = {};
    if (type === 'input' || 'textarea' || 'editor') {
      config.value = '';
    }
    return config;
  }

  /*
   * 变量 click事件
   */
  varClick(params, target, index) {
    // debugger;
    this.isShowTags = false;
    target.config.vIndex = target.config.vIndex ? target.config.vIndex : target.config.value.length;
    if (target.disabled) {
      this.isShowTags = true;
      return;
    }
    if (target.type === 'textarea') {
      this.insertByCursor(params, index);
      // this.textAreaChange(target.config);
    } else if (target.type === 'editor' && target.instance) {
      target.instance.execCommand('inserthtml', '${' + params.code + '}');
      this.isShowTags = true;
    }
  }
  /*
   * 贴片 click事件
   */
  pasterClick(item: any) {
    if (item.config.pasterClick) {
      let ins;
      if (item.type === 'textarea') {
        // ins = this.textArea.nativeElement;
        ins = this.textArea.mockTextarea.nativeElement;
      } else if (item.type === 'editor') {
        ins = this.neditor;
      }
      item.config.pasterClick(ins);
    }
  }
  /*
   * 短链 click事件
   */
  shortLinkClick(item: any, el: any) {
    if (item.config.value.includes('${traceCode}')) {
      this.dialogService.notification.error('模板编辑', '已存在短链,请擦除后再插入。');
      return;
    }
    if (item.config.shortLinkClick) {
      item.config.shortLinkClick(el);
    }
  }

  addWXShortLink(item: any) {
    if (item.config.shortLinkClick) {
      item.config.shortLinkClick(this.neditor);
    }
  }
  /*
   * textarea操作
   * 输入事件监听
   */
  textAreaChange(config) {
    const { value, pasterList } = config;
    if (pasterList) {
      config.pasterList = pasterList.filter(v => {
        return value.indexOf('${' + v.groupName + '}') > -1;
      });
    }

    if (!config.extraTag || !config.extraTag.isHasSegment) {
      return;
    }
    let segments;
    if (config.value.length <= 70) {
      segments = 1;
    } else {
      segments = Math.ceil(config.value.length / 67);
    }
    config.extraTag.segments = segments;
  }

  // 监听 fake-textarea 输入事件监听
  handelValueChange($event, config) {
    const { pasterList } = config;
    // config中的value 与 faketextarea中的value同步
    config.value = $event;
    // 根据 value中的值，动态删除多余的 pasters
    console.log('textarea value: ', $event.length);
    console.log('config: ', config);
    if (pasterList) {
      config.pasterList = pasterList.filter(v => {
        return config.value.indexOf('${' + v.groupName + '}') > -1;
      });
    }
    // 监听短链是否存在 决定是否置空uuid
    if (!config.value.includes('${traceCode}')) {
      config.targetUrl = undefined;
    }

    if (!config.extraTag || !config.extraTag.isHasSegment) {
      return;
    }
    let segments;
    if (config.value.length <= 70) {
      segments = 1;
    } else {
      segments = Math.ceil(config.value.length / 67);
    }
    config.extraTag.segments = segments;
    this.cdr.detectChanges();
  }

  /*
   * ngx-neditor操作
   * 输入事件监听
   */
  inputChange(config, selectItem?) {
    // 修改图片修改后，地址不对的问题
    let imgs = this.neditor.document.getElementsByTagName('img');
    for (let i = 0, len = imgs.length; i < len; i++) {
      let item = imgs[i];
      item.setAttribute('_src', item.getAttribute('src'));
    }
    // 重新设置特殊显示的内容编辑状态
    let pasters = this.neditor.document.getElementsByClassName('innerPaster');
    for (let i = 0; i < pasters.length; i++) {
      pasters[i].contentEditable = false;
    }
    if (selectItem) {
      selectItem[config.index] = this.neditor.getContent();
    } else {
      config.value = this.neditor.getContent();
    }

    const { value, pasterList } = config;
    console.log(value);
    if (pasterList) {
      config.pasterList = pasterList.filter(v => {
        return value.indexOf('${' + v.groupName + '}') > -1;
      });
    }
  }

  /*
   * textarea操作
   * 1. 获取光标
   * 2. 插值
   * 3. 光标聚焦
   */
  insertByCursor(varTag, index) {
    // const textAreaDom = this.textArea.nativeElement;
    // const insertVal = '${' + varTag.code + '}';
    // if (target.maxlength > 0 && target.config.value.length + insertVal.length > target.maxlength) return;
    // let _currentPosition;
    // if ((textAreaDom && textAreaDom.selectionStart) || textAreaDom.selectionStart === 0) {
    //   _currentPosition = textAreaDom.selectionStart;
    // }
    // target.config.value = target.config.value.slice(0, _currentPosition) + insertVal + target.config.value.slice(_currentPosition);
    // textAreaDom.focus();
    const temp = deepCopy(this.form[index].config);
    let { value, vIndex } = temp;
    let aPart = value.slice(0, vIndex);
    let bPart = value.slice(vIndex);
    temp.value = aPart + '${' + varTag.code + '}' + bPart;
    temp.vIndex = value.length + varTag.code.length + 3;
    this.form[index].config = deepCopy(temp);
    // 插入变量的时候，将 icc-fake-textarea 的 displayIndex，置为0，触发回显操作
    this.textArea.displayIndex = 0;
    this.cdr.detectChanges();
    this.isShowTags = true;
  }

  // 获取 blur 时候 光标
  setCursorOffset($event, template: any): void {
    template.vIndex = $event;
  }

  /*
   * 富文本初始化
   */
  nedReady(neditor: NgxNeditorComponent, item) {
    if (!neditor.Instance) return;
    this.neditor = neditor.Instance;
    item.instance = this.neditor;
    neditor.Instance.setPlaceholder(item.placeholder || '');
    if (typeof item.nedReady === 'function') {
      item.nedReady();
    }
    setTimeout(() => {
      if (item.disabled) {
        neditor.Instance.setDisabled();
      } else {
        neditor.Instance.setEnabled();
      }
    }, 0);
  }

  /*
   * 富文本销毁，移除el
   */
  neDestroy() {
    const editorEle = document.getElementsByName('editorValue');
    if (editorEle) {
      editorEle.forEach(ele => {
        ele.remove();
      });
    }
  }

  /*
   * nz-upload
   * 点击文件链接或预览图标时的回调
   */
  handlePreview = (file: UploadFile) => {
    this.previewImageSrc = file.url || file.thumbUrl;
    this.isPreviewImage = true;
  };

  test(item) {
    console.log(`item`, item);
  }
}
